import * as yup from "yup";
import { useMutation } from "@tanstack/react-query";
import moment from "moment";
import { API_DATE_FORMAT, HTTP_ENDPOINTS } from "../../consts/api";
import { http } from "../../services/HttpService";
import { removeNullishFromShape, unwrapOr } from "../../utilities/general";

const requestSchema = yup.object({
  period: yup
    .object({
      from: yup.date().nullable(),
      to: yup.date().nullable(),
    })
    .nullable(),

  order: yup
    .object({
      by: yup.string().required(),
      direction: yup.string().required(),
    })
    .nullable(),

  filter: yup.object({
    clinicIds: yup.array().of(yup.number()).nullable(),
    providerIds: yup.array().of(yup.number()).nullable(),
  }),

  rebooked: yup.boolean().nullable(),
});

export function useShareRetentionRateDetailReportToLeadArMutation(
  options = {},
) {
  return useMutation(async (payload) => {
    const req = requestSchema.validateSync(payload, {
      strict: true,
    });

    const fromDate = unwrapOr(
      () => moment(req.period.from).format(API_DATE_FORMAT),
      null,
    );
    const toDate = unwrapOr(
      () => moment(req.period.to).format(API_DATE_FORMAT),
      null,
    );

    return await http.post(
      HTTP_ENDPOINTS.createRetentionRateDetailsReport(),
      removeNullishFromShape({
        start_date: fromDate,
        end_date: toDate,
        sortBy: unwrapOr(() => req.order.by, null),
        order: unwrapOr(() => req.order.direction, null),
        clinic_ids: req.filter.clinicIds || null,
        provider_ids: req.filter.providerIds || null,
        rebooked: req.rebooked || false,
        share: true,
      }),
    );
  }, options);
}
